import '@main';
import '@vendor/swiper/swiper-bundle.min.js';

u.importCSS('@vendor/swiper/swiper-bundle.min.css');

function updateFractionPagination(swiper: any, paginationNumSelector: string): void {
  const fractionEl = document.querySelector(paginationNumSelector) as HTMLElement;
  if (fractionEl) {
    fractionEl.textContent = `${swiper.realIndex + 1} / ${swiper.slides.length}`;
  }
}

// now-showing
const showingSwiper = new Swiper(".l-showing-swiper", {
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    1199: {
      slidesPerView: 3,
    }
  },
  navigation: {
    nextEl: ".j-showing-swiper-button-next",
    prevEl: ".j-showing-swiper-button-prev",
  },
  pagination: {
    el: ".j-showing-pagination-progressbar",
    type: "progressbar",
  },
  on: {
    init: (swiper) => {
      updateFractionPagination(swiper, '.j-swiper-pagination-number');
    },
    slideChange: (swiper) => {
      updateFractionPagination(swiper, '.j-swiper-pagination-number');
    },
  },
});

// announcements
const articleSwiper = new Swiper(".j-article-swiper", {
  slidesPerView: 1,
  navigation: {
    nextEl: ".j-article-swiper-button-next",
    prevEl: ".j-article-swiper-button-prev",
  },
  pagination: {
    el: ".j-article-pagination-progressbar",
    type: "progressbar",
  },
  on: {
    init: (swiper) => {
      updateFractionPagination(swiper, '.j-article-pagination-number');
    },
    slideChange: (swiper) => {
      updateFractionPagination(swiper, '.j-article-pagination-number');
    },
  },
});

const articleMobileSwiper = new Swiper(".j-article-mobile-swiper", {
  slidesPerView: 1,
  navigation: {
    nextEl: ".j-article-mobile-swiper-button-next",
    prevEl: ".j-article-mobile-swiper-button-prev",
  },
  pagination: {
    el: ".j-article-mobile-pagination-progressbar",
    type: "progressbar",
  },
  on: {
    init: (swiper) => {
      updateFractionPagination(swiper, '.j-article-mobile-pagination-number');
    },
    slideChange: (swiper) => {
      updateFractionPagination(swiper, '.j-article-mobile-pagination-number');
    },
  },
});
